import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    title: true,  
    name: 'Collabarator'
    },
  {
    name: 'Collabos',
    url: '/collabo',
    icon: 'icon-star'

  },
  {
    name: 'Quotations',
    url: '/quote',
    icon: 'fa fa-dollar'

  },
    {
      name: 'Messages',
      url: '/message',
      icon: 'fa fa-envelope-open'
  
    }, 
       {
    name: 'Invoices',
    url: '/overview',
    icon: 'fa fa-file-text'

  },
   {
    name: 'Dashboard',
    url: '/payment',
    icon: 'fa fa-dashboard'

  },
];
export const navItems1: INavData[] =[
  {
    title: true,  
    name: 'Initiator'
    },
 {
  name: 'Collabos',
  url: 'initatorcollabo/0/0',
  icon: 'icon-star',
 },
   {
     name: 'Cost',
   url: '/cost',
   icon: 'fa fa-dollar',
 },
 {
   name: 'Messages',
 url: '/initatormessage',
 icon: 'fa fa-envelope-open',
  },
  
 {
 name: 'Invoices',
 url: '/pay',
 icon: 'fa fa-file-text',
 },
 {
   name: 'Dashboard',
 url: '/initatordashboard',
 icon: 'fa fa-dashboard',
 },
 
];
export const navItems2: INavData[] =[
  {
    title: true,  
    name: 'Admin'
    },
    {
      name: 'Dashboard',
    url: '/admindashboard',
    icon: 'icon-home',
    },
    {
      name: 'Financial Dashboard',
    url: '/financialdashboard',
    icon: 'fa fa-dollar',
    },
    {
    name: 'Location',
  url: '/location',
  icon: 'icon-pin',
  },
  {
    name: 'Skills',
  url: '/skills',
  icon: 'icon-bulb',
  },
  {
    name: 'Category',
  url: '/category',
  icon: 'icon-star',
  },
  {
    name: 'Users',
  url: '/users',
  icon: 'icon-user',
  },
  {
    name: 'Collabos',
  url: '/collabos',
  icon: 'icon-star',
  },
  {
    name: 'CMS',
  url: '/cms',
  icon: 'icon-folder',
  },
  {
    name: 'Emails',
  url: '/emails',
  icon: 'icon-envelope',
  },
  {
    name: 'Plans',
  url: '/plans',
  icon: 'icon-star',
  },
  {
    name: 'service charge',
  url: '/csc',
  icon: 'icon-star',
  },
    {
      name: 'Create Admin',
      url: '/admin-signup',
      icon: 'icon-user',
      },
    {
      name: 'Roles',
      url: '/roles',
      icon: 'icon-drop',
      },
   
];
